import AppManager from 'react-aem-vendor-libs';
import ReactGA from 'react-ga';
import routes from './routes';
import './styles/main.less';

import contactFormReducer from './redux/contactForm';
import formValidationReducer from './redux/formValidation';
import gasConnectionReducer from './redux/gasConnection';
import renewalgasConnectionReducer from './redux/renewalgasConnection';
import registrationLibraryEventReducer from './redux/registrationLibraryEvent';
import applicationCitizenEnergyPriceReducer from './redux/applicationCitizenEnergyPrice';
import checklistEnergyStorageReducer from './redux/checklistEnergyStorage';
import gasConnectionNewReducer from './redux/gasConnectionNew';
import gasDecommissionReducer from './redux/gasDecommission';
import onlineDecommissionReducer from './redux/onlineDecommission';
import gridConnectionReducer from './redux/gridConnection';
import jobSearchReducer from './redux/jobSearch';
import multiHouseReducer from './redux/multiHouse';
import municipalityEasyContactReducer from './redux/municipalityEasyContact';
import municipalityContactReducer from './redux/municipalityContact';
import newsletterRegistrationReducer from './redux/newsletterRegistration';
import powerSharesReducer from './redux/powerShares';
import searchReducer from './redux/search';
import shutOffDeviceReducer from './redux/shutOffDevice';
import gmReducer from './redux/googleMaps';
import hvRReducer from './redux/highVoltageRegister';
import onlineConnectionReducer from './redux/onlineConnection';
import pipelineReducer from './redux/pipeline';
import ewiRegistrationReducer from './redux/ewiRegistration';
import ewiMeterReadingReducer from './redux/ewiMeterReading';
import ewiReregistrationReducer from './redux/ewiReregistration';
import ewiCancellationReducer from './redux/ewiCancellation';
import ewiDirectDebitReducer from './redux/ewiDirectDebit';
import hausanschlussReducer from './redux/hausanschlussForm';
import eInternetAccessReducer from './redux/eInternnetAccess';
import eTransmissionPathReducer from './redux/eTransmissionPath';
import customerAdvisoryBoardReducer from './redux/customerAdvisoryBoard';
import enerOptReducer from './redux/enerOpt';
import avaconGasConnectionCampaignReducer from './redux/avaconGasConnectionCampaign';
import zipContactSearchReducer from './redux/zipContactSearch';
import searchMarketplaceChangeLastDateByZipcodeReducer from './redux/searchMarketplaceChangeLastDateByZipcode';
import earlyCommissionImsysFormReducer from './redux/earlyCommissionImsysForm';
import museumTourRegistrationReducer from './redux/museumTourRegistration';
import coronaSponsoringFormReducer from './redux/coronaSponsoringForm';
import customerDataFormReducer from './redux/customerDataForm';
import dynamicFormReducer from './redux/dynamicForm';


// eslint-disable-next-line no-undef
if (process.env.NODE_ENV === 'development') {
  window.onload = function () {
    ReactGA.initialize('UA-XXXXXXXX-X', {
      debug: true,
      titleCase: false
    });
  };
}

// HACK for AEM, the scripts are relative to the main.js
const startDkeApp = () => {
  const MODE = true ? 'AUTH' : 'PUBLISH'; // eslint-disable-line
  const PATH = MODE === 'AUTH' ? 'clientlib-webpack-author' : 'clientlib-webpack-publish';
  const myScripts = document.getElementsByTagName('script');
  window.myDir = myScripts[myScripts.length - 1].src.split('?')[0].split('/').slice(0, -1).join('/') +
    (process.env.NODE_ENV === 'production' ? `/${PATH}/js/` : '/');
  AppManager.startApp(routes, {
    contactFormReducer,
    formValidationReducer,
    gasConnectionReducer,
    renewalgasConnectionReducer,
    registrationLibraryEventReducer,
    applicationCitizenEnergyPriceReducer,
    checklistEnergyStorageReducer,
    gasConnectionNewReducer,
    gasDecommissionReducer,
    onlineDecommissionReducer,
    gridConnectionReducer,
    jobSearchReducer,
    multiHouseReducer,
    municipalityEasyContactReducer,
    municipalityContactReducer,
    newsletterRegistrationReducer,
    powerSharesReducer,
    searchReducer,
    shutOffDeviceReducer,
    gmReducer,
    hvRReducer,
    onlineConnectionReducer,
    pipelineReducer,
    ewiRegistrationReducer,
    ewiMeterReadingReducer,
    ewiReregistrationReducer,
    ewiCancellationReducer,
    ewiDirectDebitReducer,
    hausanschlussReducer,
    eInternetAccessReducer,
    eTransmissionPathReducer,
    customerAdvisoryBoardReducer,
    enerOptReducer,
    avaconGasConnectionCampaignReducer,
    zipContactSearchReducer,
    searchMarketplaceChangeLastDateByZipcodeReducer,
    earlyCommissionImsysFormReducer,
    museumTourRegistrationReducer,
    coronaSponsoringFormReducer,
    customerDataFormReducer,
    dynamicFormReducer
  });
};
export default startDkeApp;

